export const LOAD_FROM_CACHE = 'LOAD_FROM_CACHE'
export const PROJECTS = 'PROJECTS'

// User Profile
export const USER_PROFILE_LOGIN = 'USER_PROFILE_LOGIN'
export const USER_PROFILE_SET = 'USER_PROFILE_SET'
export const USER_PROFILE_LOGOUT = 'USER_PROFILE_LOGOUT'

// Network Manager
export const NM_ONLINE = 'NM_ONLINE'
export const NM_OFFLINE = 'NM_OFFLINE'
export const NM_SERVER_ONLINE = 'NM_SERVER_ONLINE'
export const NM_SERVER_OFFLINE = 'NM_SERVER_OFFLINE'